import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faAngleLeft, faChevronLeft} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Routes } from "../../routes";
import NotFoundImage from "../../assets/img/illustrations/404.svg";

export default () => {
    return (
        <main style={{ minHeight: "100vh", background: "linear-gradient(135deg, #1e1d45 0%, #2d2c6b 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
            <div style={{ width: "100%", maxWidth: 480, textAlign: "center" }}>
                {/* Ilustração */}
                <div style={{ marginBottom: 32 }}>
                    <img src={NotFoundImage} alt="404" style={{ width: "100%", maxWidth: 280, opacity: 0.9 }} />
                </div>

                {/* Card */}
                <div style={{ background: "white", borderRadius: 20, padding: "36px 32px", boxShadow: "0 24px 60px rgba(0,0,0,0.3)" }}>
                    <div style={{ fontSize: 72, fontWeight: 900, color: "#1e1d45", lineHeight: 1, marginBottom: 8, fontFamily: "'Anton', sans-serif" }}>404</div>
                    <h2 style={{ fontWeight: 800, fontSize: 22, color: "#1e1d45", marginBottom: 8 }}>Página não encontrada</h2>
                    <p style={{ color: "#9ca3af", fontSize: 15, marginBottom: 28, lineHeight: 1.6 }}>
                        Ups! Parece que seguiu um link incorreto. Se achar que é um problema nosso, por favor avise-nos.
                    </p>

                    <Link to="/" style={{ textDecoration: "none" }}>
                        <button style={{ width: "100%", height: 50, background: "#1e1d45", border: "none", borderRadius: 12, color: "white", fontWeight: 700, fontSize: 15, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                            <FontAwesomeIcon icon={faChevronLeft} /> Voltar ao início
                        </button>
                    </Link>
                </div>
            </div>
        </main>
    );
};
